import * as THREE from 'three';
require('three-orbitcontrols');

import printModel from '../../../3dapps/mixins/printModel';
import { initThree, scene, camera, renderer, incRenderCount, createFloor } from './initThree';
import XDialog from 'vux/src/components/x-dialog/index.vue'
import Range from 'vux/src/components/range/index.vue'
import Radio from 'vux/src/components/radio/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Checker from 'vux/src/components/checker/checker.vue'
import CheckerItem from 'vux/src/components/checker/checker-item.vue'
import XSwitch from 'vux/src/components/x-switch/index.vue'
import XProgress from 'vux/src/components/x-progress/index.vue'
import Box from 'vux/src/components/box/index.vue'

import loading from '@/components/loading';

import { PenholderMaker } from './MakePenholder.js';


let maker = new PenholderMaker();
let cutPath;
let cutPathBox = new THREE.Box2();
let pRectCenter;
let pBox;

import relief1 from '../imgs/装饰1.svg';
import relief2 from '../imgs/装饰2.svg';
import relief3 from '../imgs/装饰3.svg';
import relief4 from '../imgs/装饰4.svg';
import relief5 from '../imgs/装饰5.svg';
import relief6 from '../imgs/装饰6.svg';
import relief7 from '../imgs/装饰7.svg';
import relief8 from '../imgs/装饰8.svg';
import relief9 from '../imgs/装饰9.svg';
import relief10 from '../imgs/装饰10.svg';
import relief11 from '../imgs/装饰11.svg';
import relief12 from '../imgs/装饰12.svg';
import relief13 from '../imgs/装饰13.svg';
import relief14 from '../imgs/装饰14.svg';
import relief15 from '../imgs/装饰15.svg';
import relief16 from '../imgs/装饰16.svg';
import relief17 from '../imgs/装饰17.svg';
import relief18 from '../imgs/装饰18.svg';
import relief19 from '../imgs/装饰19.svg';
import relief20 from '../imgs/装饰20.svg';


export default {
name: "penholder",
mixins: [printModel],
components: {
XDialog,
range: Range, radio: Radio, Group, Cell, loading, Checker, CheckerItem, XSwitch, XProgress, Box
},
data() {
return {
quotationName: "贴纸雕刻笔筒",
productType: "贴纸雕刻笔筒",
landscape: true,//竖屏状态要一直为true
showLoading: false,
showPrint: false,
showPrintImg: true,
showdownloadImg: true,
showDownloads: false,
showTabList: false,
addCartIndex: -1,
orderIndex: -1,
cur: 0, //默认选中第一个tab
btnsListIndex1: -1,
isReliefIndex: 0,
disabled: false,
showMenu: true,
showSizeImg: true,
showSizePop: false,
draw: {
l: 80,//长
w: 80,//宽
h: 100,//高
r: Number(20 / Math.min(40, 40)).toFixed(1),//半径
xposition: Number(0.5).toFixed(1),//水平位置
yposition: Number(0.5).toFixed(1),//垂直位置
scale: 1,//缩放
rotation: 0,//旋转
},
btnsList1: [
{
isClick: false,
icon: require("../imgs/设置.png"),
iconClick: require("../imgs/设置（选中）.png"),
},
],
tabTitle: [
{
title: '贴纸',
enabled: true,
},
{
title: '位置',
enabled: true,
},
{
title: '缩放',
enabled: true,
},
{
title: '旋转',
enabled: true,
},
],
reliefList: [
{
src: relief1,
},
{
src: relief2,
},
{
src: relief3,
},
{
src: relief4,
},
{
src: relief5,
},
{
src: relief6,
},
{
src: relief7,
},
{
src: relief8,
},
{
src: relief9,
},
{
src: relief10,
},
{
src: relief11,
},
{
src: relief12,
},
{
src: relief13,
},
{
src: relief14,
},
{
src: relief15,
},
{
src: relief16,
},
{
src: relief17,
},
{
src: relief18,
},
{
src: relief19,
},
{
src: relief20,
},
],
positionsList: [
{
title: '水平'
},
{
title: '垂直'
}
],
}
},
mounted() {
const scope = this;
scope.showLoading = true;
console.log(scope.draw);

var mo = function (e) {
e.preventDefault();
}

initThree(scope.$refs.canvas);
scope.floor = createFloor();


const contentDOM = scope.$refs.penholder;


const resize1 = function (e) {
if (!scope.$refs.canvas) return;


let w = scope.$refs.canvasBox.clientWidth;
let h = scope.$refs.canvasBox.clientHeight;



scope.$refs.canvas.width = w; 
scope.$refs.canvas.height = h; 



camera.aspect = w / h;

camera.updateProjectionMatrix();

renderer.setSize(w, h);
}

scope.init3d(contentDOM, camera, renderer, resize1);



scope.$nextTick(function () {
scope.$refs.penholder.style.paddingTop = '0px';
scope.$refs.penholder.style.overflow = 'hidden';
scope.$refs.canvasBox.addEventListener("touchmove", mo, false);
});



var decorativePainting = this.$refs.tabList; 


var screenHeight = window.innerHeight;
window.onresize = function () {
if (screenHeight !== window.innerHeight) {

decorativePainting.style.bottom = 0 + "px";
decorativePainting.style.position = "absolute";
} else {

decorativePainting.style.bottom = 55 + "px";
decorativePainting.style.position = "fixed";
}
};
window.addEventListener("resize", onresize);


var interval;


decorativePainting.onfocus = function () {
interval = setInterval(function () {
decorativePainting.style.bottom = 0 + "px";
decorativePainting.style.position = "absolute";
}, 500)
};


decorativePainting.onblur = function () {
decorativePainting.style.bottom = 55 + "px";
decorativePainting.style.position = "fixed";
clearInterval(interval);
};

incRenderCount();

maker.makeMesh(scene);

scope.$nextTick(function () {
scope.loadData();
});
},
methods: {
updateMesh() {
if (this.noUpdateMesh) return;
this.showLoading = true;
incRenderCount();
},

isSizeClick() {
this.isTopBtn();
this.showSizeImg = !this.showSizeImg;
this.showSizePop = !this.showSizePop;
},

touchend() {
this.showLoading = true;
setTimeout(() => {
this.noUpdateMesh = false;
let scale = Number(this.draw.scale);
let rotate = THREE.Math.degToRad(Number(this.draw.rotation));
let translate = new THREE.Vector2((Number(this.draw.xposition) * 0.25 + 0.375) * pBox.width, Number(this.draw.yposition) * pBox.height);
maker.makeModelWithRelief2(cutPath.map(path => path.map(shape => shape.map(p =>
p.clone().multiplyScalar(scale).rotateAround(new THREE.Vector2(0, 0), rotate).add(translate)
))));
incRenderCount();
this.showLoading = false;
}, 50);
},

touchend1() {
this.showLoading = true;
setTimeout(() => {
this.noUpdateMesh = false;
maker.updateSize(Number(this.draw.l), Number(this.draw.w), Number(this.draw.h), Number(this.draw.r));
let scale = Number(this.draw.scale);
let rotate = THREE.Math.degToRad(Number(this.draw.rotation));
let translate = new THREE.Vector2((Number(this.draw.xposition) * 0.25 + 0.375) * pBox.width, Number(this.draw.yposition) * pBox.height);
maker.makeModelWithRelief2(cutPath.map(path => path.map(shape => shape.map(p =>
p.clone().multiplyScalar(scale).rotateAround(new THREE.Vector2(0, 0), rotate).add(translate)
))));
incRenderCount();
this.showLoading = false;
this.showSizePop = false;
this.showSizeImg = true;
}, 50);
},

selereliefItem(index) {
this.showLoading = true;
this.isReliefIndex = index;
setTimeout(() => {
console.log("selereliefItem", this.isReliefIndex);
maker.loadPathsFromSVG(this.reliefList[this.isReliefIndex].src).then(cutPathsList => {
cutPath = cutPathsList;



cutPathBox = new THREE.Box2();
cutPath.forEach(path => { path.forEach(shape => { shape.forEach(p => { cutPathBox.expandByPoint(p); }) }) });
console.log(cutPathBox);
pBox = maker.getPRect();
console.log(pBox);
let initPadding = 10;
let innerHeight = pBox.height - pBox.padding * 2 - initPadding * 2;
let innerWidth = pBox.width - pBox.padding * 2 - initPadding * 2;
let cutPathBoxSize = cutPathBox.getSize();
let scale = scale;
if (innerWidth / innerHeight > cutPathBoxSize.x / cutPathBoxSize.y) {
scale = innerHeight / cutPathBoxSize.y;
} else {
scale = innerWidth / cutPathBoxSize.x;
}

let cutPathBoxCenter = cutPathBox.getCenter();
pRectCenter = new THREE.Vector2(pBox.width / 2, pBox.height / 2);
cutPath.forEach(path => {
path.forEach(shape => {
shape.forEach(p => {
p.sub(cutPathBoxCenter);
p.multiplyScalar(scale);
})
})
});
console.log(scale);
maker.makeModelWithRelief2(cutPath.map(path => path.map(shape => shape.map(p =>
p.clone().add(pRectCenter)
))));
incRenderCount();
this.showLoading = false;
});
}, 50);
},


loadData() {
const scope = this;
if (window.localStorage) {
let dataStr = localStorage.getItem("penholder");
localStorage.removeItem("penholder"); 
if (dataStr) {
scope.showLoading = true;
scope.noUpdateMesh = false;

let data = JSON.parse(dataStr);
scope.reliefList = data.reliefList;
scope.isReliefIndex = data.isReliefIndex;
scope.btnsListIndex1 = data.btnsListIndex1;
scope.draw.l = data.l;
scope.draw.w = data.w;
scope.draw.h = data.h;
scope.draw.r = data.r;
scope.draw.xposition = data.xposition;
scope.draw.yposition = data.yposition;
scope.draw.scale = data.scale;
scope.draw.rotation = data.rotation;
} else {
console.log("err");
}

maker.loadPathsFromSVG(scope.reliefList[scope.isReliefIndex].src).then(cutPathsList => {
cutPath = cutPathsList;


cutPathBox = new THREE.Box2();
cutPath.forEach(path => { path.forEach(shape => { shape.forEach(p => { cutPathBox.expandByPoint(p); }) }) });
console.log(cutPathBox);
pBox = maker.getPRect();
console.log(pBox);
let initPadding = 10;
let innerHeight = pBox.height - pBox.padding * 2 - initPadding * 2;
let innerWidth = pBox.width - pBox.padding * 2 - initPadding * 2;
let cutPathBoxSize = cutPathBox.getSize();
let scale = 1.0;
if (innerWidth / innerHeight > cutPathBoxSize.x / cutPathBoxSize.y) {
scale = innerHeight / cutPathBoxSize.y;
} else {
scale = innerWidth / cutPathBoxSize.x;
}

let cutPathBoxCenter = cutPathBox.getCenter();
pRectCenter = new THREE.Vector2(pBox.width / 2, pBox.height / 2);
cutPath.forEach(path => {
path.forEach(shape => {
shape.forEach(p => {
p.sub(cutPathBoxCenter);
p.multiplyScalar(scale);
})
})
});
console.log(scale);
maker.makeModelWithRelief2(cutPath.map(path => path.map(shape => shape.map(p =>
p.clone().add(pRectCenter)
))));
incRenderCount();
});
setTimeout(() => {
scope.showLoading = false;
}, 50);
}
},


saveData() {
const scope = this;
if (window.localStorage) {
let data = {};
data.reliefList = scope.reliefList;
data.isReliefIndex = scope.isReliefIndex;
data.btnsListIndex1 = scope.btnsListIndex1;
data.l = scope.draw.l;
data.w = scope.draw.w;
data.h = scope.draw.h;
data.r = scope.draw.r;
data.xposition = scope.draw.xposition;
data.yposition = scope.draw.yposition;
data.scale = scope.draw.scale;
data.rotation = scope.draw.rotation;
localStorage.setItem("penholder", JSON.stringify(data));
}
},

handler1(index) {
this.btnsListIndex1 = index;
this.showSetImg = !this.showSetImg;
this.showTabList = !this.showTabList;
this.btnsList1[0].isClick = true;
this.resize();
if (!this.showTabList) {
this.btnsList1[0].isClick = false;
this.optimizedBtnClick();
this.resize();
return;
}
return;
},


downloadsBtn() {
this.isTopBtn();
this.showDownloads = !this.showDownloads;
this.showdownloadImg = !this.showdownloadImg;
},


downloads() {
const scope = this;
scope.showDownloads = false;
scope.showLoading = true;

if (maker.mesh) {

if (!this.$common.getCookie('_token')) {

scope.saveData();

this.$router.push({
path: '/login',
query: {
fullPath: this.$route.fullPath
}
});
scope.showLoading = false;
} else {
scope.$request.post('/SmallSoftware/requestDownload', {
type: "penholder",
}).then(function (res) {
console.log("res", res);
if (res.obj === true) {
scope.downloadModels();
setTimeout(() => {
scope.$vux.toast.show({
text: '下载成功',
type: "success",
time: 2000,
position: "middle",
});
scope.isTopBtn();
scope.showLoading = false;
}, 50);
} else {
scope.$vux.toast.show({
text: '下载失败',
type: "warn",
time: 2000,
position: "middle",
});
}
});
}
}
},

downloadModels() {
let exporter = new THREE.STLExporter();
let result = exporter.parse(maker.mesh, { binary: true });
let blob = new Blob([result], { type: 'application/octet-stream' });
let filename = "贴纸雕刻笔筒.stl";
let link = document.createElement("a");
link.href = URL.createObjectURL(blob);
link.download = filename;
link.click();
},

optimizedBtnClick() {
this.showSetImg = true;
this.btnsList1[0].isClick = false;
this.btnsListIndex1 = -1;
},

optimizedPopClick() {
this.showPrint = false;
this.showTabList = false;
this.showOrnamentPop = false;
this.showDownloads = false;
this.showdownloadImg = true;
this.showPrintImg = true;
this.showSizeImg = true;
this.showSizePop = false;
},


touchstart() {
this.isTopBtn();
this.resize();
},

isTopBtn() {
this.optimizedPopClick();
this.optimizedBtnClick();
this.resize();
},


resize() {
let w = document.documentElement.clientWidth;
let h = document.documentElement.clientHeight;
if (this.btnsListIndex1 == 0 || this.btnsListIndex1 == 1) {
let tabHeight = h * 0.2;
h = h - tabHeight;
}
camera.aspect = w / h;
camera.updateProjectionMatrix();
renderer.setSize(w, h);
incRenderCount();
},

getModelToPrint() {
return maker.mesh;
},

makeStlBlob() {
let exporter = new THREE.STLExporter();
let group = maker.mesh;

let result = exporter.parse(group, { binary: true });
let blob = new Blob([result], { type: 'application/octet-stream' });
return blob;
},

closePrint() {
this.isTopBtn();
},

getUploadUrl() {
return "/SmallSoftware/uploadFile";
},


print() {
this.modelSplit = true;
this.isTopBtn();
this.showLoading = true;
this.showPrintImg = !this.showPrintImg;

if (this.lowPrice == 0 && this.total <= 5 || this.total == 5) {
this.showlow = true;
this.showStyle = false;
this.showlowpriceHeight = true;
}
if (this.lowPrice == 1 && this.total > 5 || this.total > 5 || this.lowPrice == "") {
this.showlow = false;
this.showStyle = true;
this.showlowpriceHeight = false;
}

setTimeout(() => {
if (maker.mesh) {
this.saveData();
this.noUpdateMesh = false;
this.updateMesh();
this.$nextTick(function () {
this.showPrint = true;
this.makeModelForPrint();
this.getPrice();
});
} else {
this.$vux.toast.show({
text: '定制装饰画不能为空！',
type: "warn",
time: 2000,
position: "middle",
});
this.noUpdateMesh = false;
this.updateMesh();
}
incRenderCount();
this.showLoading = false;
}, 50);
},
},
}



// WEBPACK FOOTER //
// ./src/views/penholder/scripts/penholder.js